import { Control, Controller, Path } from 'react-hook-form'
import { MenuItem, Select, Stack, Typography } from '@mui/material'

import { SearchTaskStatusFormData } from 'interface/search'
import { Options } from 'interface/search/statusList'

type SearchStatusSelectProps = {
  control: Control<SearchTaskStatusFormData>
  name: Path<SearchTaskStatusFormData>
  id: string
  label: string
  options: Options
}
export const SearchStatusSelect = ({
  control,
  name,
  id,
  label,
  options,
}: SearchStatusSelectProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Stack direction="column" spacing={0.5}>
          <Typography variant="body2" paddingX={1}>{label}</Typography>
          <Select
            id={id}
            fullWidth
            size="small"
            {...field}
          >
            {options.map((status) => (
              <MenuItem key={status.value} value={status.value}>
                {status.label}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      )}
    />
  )
}
